module.exports = __webpack_public_path__ + "static/media/2.722b6a3b.jpg";